
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';
import Multiselect from 'vue-multiselect';

export default defineComponent({
  name: 'PhonePrefix',
  components: {
    Multiselect,
  },
  data() {
    return {
      phonePrefixes: config.PHONE_PREFIXES,
    };
  },
});
